/**
 * Explore Unknown — opponent faction per global mission index (React client copy).
 *
 * Canonical JSON: `config/exploreUnknownMissionOpponentFactions.json` (regenerate via
 * `node scripts/generate-explore-unknown-mission-factions.js`).
 * CRA cannot import repo-root config; keep this module aligned with that file.
 */

/** @type {Readonly<Record<string, string>>} */
const EXPLORE_UNKNOWN_MISSION_OPPONENT_FACTION_BY_INDEX = Object.freeze({
  1: 'Remnants of Humanity',
  2: 'The Silent Accord',
  3: 'The Forsaken Pact',
  4: 'The Iron Alliance',
  5: 'The Last Crusade',
  6: 'The Shadow Consortium',
  7: 'The Conspiracy',
  8: 'The Covenant',
  9: 'League of Shadows',
  10: 'The Silent Accord',
  11: "Ra's Children",
  12: 'The Hollow',
  13: 'The Last Crusade',
  14: 'The Divine Syndicate',
  15: 'The Last Crusade',
  16: 'The Covenant',
  17: 'Asrah',
  18: 'The Conspiracy',
  19: 'The Corrupted Core',
  20: 'The Conspiracy',
  21: 'The Hollow',
  22: 'The Forsaken Pact',
  23: 'Remnants of Humanity',
  24: 'Exolot Dominion',
  25: 'The Divine Syndicate',
  26: 'The Iron Alliance',
  27: 'The Shadow Consortium',
  28: 'The Last Crusade',
  29: 'The Iron Alliance',
  30: 'The Corrupted Core',
  31: "Ra's Children",
  32: 'Asrah',
  33: 'Exolot Dominion',
  34: 'The Iron Alliance',
  35: 'The Silent Accord',
  36: 'The Conspiracy',
  37: 'The Shadow Consortium',
  38: 'The Divine Syndicate',
  39: 'The Forsaken Pact',
  40: 'The Last Crusade',
  41: 'League of Shadows',
  42: 'The Silent Accord',
  43: 'The Conspiracy',
  44: 'The Forsaken Pact',
  45: 'The Hollow',
  46: 'The Shadow Consortium',
  47: 'League of Shadows',
  48: 'The Silent Accord',
  49: 'The Conspiracy',
  50: 'The Forsaken Pact',
  51: 'The Silent Accord',
  52: 'The Conspiracy',
  53: 'League of Shadows',
  54: 'Asrah',
  55: 'The Conspiracy',
  56: 'The Hollow',
  57: 'The Forsaken Pact',
  58: 'Asrah',
  59: 'The Conspiracy',
  60: 'The Hollow',
  61: 'Asrah',
  62: 'The Conspiracy',
  63: 'The Hollow',
  64: 'The Forsaken Pact',
  65: 'Asrah',
  66: 'The Conspiracy',
  67: 'The Hollow',
  68: 'Asrah',
  69: 'The Conspiracy',
  70: 'The Conspiracy',
  71: 'The Conspiracy',
  72: 'The Conspiracy',
  73: 'The Conspiracy',
  74: 'The Conspiracy',
  75: 'League of Shadows',
});

/**
 * @param {number} missionIndex
 * @returns {string}
 */
export function getExploreUnknownMissionOpponentFactionName(missionIndex) {
  if (!Number.isInteger(missionIndex) || missionIndex < 1) {
    throw new Error(
      `getExploreUnknownMissionOpponentFactionName: invalid missionIndex (${String(missionIndex)})`
    );
  }
  const factionName = EXPLORE_UNKNOWN_MISSION_OPPONENT_FACTION_BY_INDEX[missionIndex];
  if (!factionName) {
    throw new Error(
      `getExploreUnknownMissionOpponentFactionName: no opponent faction configured for mission ${missionIndex}`
    );
  }
  return factionName;
}

export { EXPLORE_UNKNOWN_MISSION_OPPONENT_FACTION_BY_INDEX };
